module.exports = __webpack_public_path__ + "static/garden-herbs-75b908f5768fa48aefa5219896a5bb1f.jpg";